import React, { useContext } from 'react'
import CallButton from '../common/CallButton'
import { SipContext } from '~/service/SipConn'
import { useLocation } from 'react-router-dom'
import { formatPhoneNumber } from '~/utils/string'
import { LanguageIcon } from '../common/LanguageIcon'

const CallNotify: React.FC = ({}) => {
  const { incomingCall, shownCall } = useContext(SipContext)
  const { pathname } = useLocation()

  if (!incomingCall) {
    return null
  }

  if (pathname == '/phone' && !shownCall) {
    return null
  }

  return (
    <div className="phone-incomingNotify">
      {incomingCall.client && <img src={incomingCall.client.avatar} />}

      <div>
        {incomingCall.client
          ? incomingCall.client.name
          : formatPhoneNumber(incomingCall.number)}

        {incomingCall.apiData && <LanguageIcon call={incomingCall.apiData} />}

        {incomingCall.apiData && incomingCall.apiData.ivr && (
          <div className="phone-incomingNotify-ivr">
            {incomingCall.apiData.ivr}
          </div>
        )}
      </div>
      <CallButton onClick={incomingCall.answer} />
      <CallButton onClick={incomingCall.reject} reject />
    </div>
  )
}

export default CallNotify
